import { HotelSupplementFormData } from '@/types/benefits/hotel/HotelSupplementSchema';

/**
 * Serializes form hotel supplements for API submission (e.g. FormData or JSON).
 * Used by both create and edit hotel flows.
 */
export const serializeHotelSupplements = (
  supplements: HotelSupplementFormData[] | undefined,
) => {
  if (!supplements) return [];
  return supplements.map((supplement) => ({
    name: supplement.name,
    pensionTypes: supplement.pensionTypes,
    pricingList: supplement.pricingList.map((pricing) => ({
      name: pricing.name,
      periods: (pricing.periods ?? []).map((period) => ({
        startDate: period.startDate ? new Date(period.startDate) : null,
        endDate: period.endDate ? new Date(period.endDate) : null,
        applicationDays: period.applicationDays ?? [],
      })),
      pricing: pricing.pricing
        ? {
            adultPrice:
              pricing.pricing.adultPrice != null
                ? Number(pricing.pricing.adultPrice)
                : null,
            childPrice:
              pricing.pricing.childPrice != null
                ? Number(pricing.pricing.childPrice)
                : null,
            adolescentPrice:
              pricing.pricing.adolescentPrice != null
                ? Number(pricing.pricing.adolescentPrice)
                : null,
          }
        : undefined,
    })),
  }));
};
